import classNames from 'classnames'
import { DefineComponentProps } from 'utils'
import type { VNode } from 'vue'
import { ArrowRight } from '..'
import { CopyText } from '../../../crypto-otc/src/components/Copy'
import './ListCell.scss'

interface ListCellProps {
  title: string
  subTitle?: string
  description?: string | VNode
  isArrow?: boolean
  onClick?: (e: MouseEvent) => void
  prefix?: VNode
  class?: string
  isCopy?: boolean
  isShowTooltip?: boolean
  onTooltipClick?: () => void
}

export const ListCell = defineComponent<ListCellProps>({
  props: DefineComponentProps<ListCellProps>(['title', 'subTitle', 'description', 'isArrow', 'onClick', 'prefix', 'class', 'isCopy', 'isShowTooltip', 'onTooltipClick']),

  setup(props) {
    return () => (
      <div class={classNames('list-cell', props.class)} onClick={props.onClick}>
        <div class="left-box">
          {props.prefix && <span class="prefix">{props.prefix}</span>}
          <div class="title-box">
            <span class={classNames('list-cell-title', { 'show-tooltip': props.isShowTooltip })} onClick={props.onTooltipClick}>
              {props.title}
            </span>
            {props.subTitle && <span class="list-cell-sub-title">{props.subTitle}</span>}
          </div>
        </div>
        <div class="right-box">
          <span class="list-cell-description">{props.description}</span>
          {props.isArrow && <ArrowRight />}
          {props.isCopy && typeof props.description === 'string' && <CopyText value={props.description} />}
        </div>
      </div>
    )
  },
})
